import BaseApiModel from "scripts/models/baseApiModel";

class LibraryCardLinkClickModel extends BaseApiModel {
  url() {
    return `${this.apiUrlRoot}/tracking/library-card-clicks`;
  }
}

export default LibraryCardLinkClickModel;
